import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    getplanlist,
    Deleteplan,
    changeplanstatus,
    getActivecategoryplan
} from '../../../Services/Admin/Admin';
import { fDateTime } from '../../../../Utils/Date_formate';
import Loader from '../../../../Utils/Loader';
import Content from '../../../components/Contents/Content';
import ReusableModal from '../../../components/Models/ReusableModal';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';




const Plan = () => {



    const [clients, setClients] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [showViewModal, setShowViewModal] = useState(false);
    const [visibleCount, setVisibleCount] = useState(10);
    const [expanded, setExpanded] = useState(false);
    const [activeTab, setActiveTab] = useState('all');
    const token = localStorage.getItem('token');

    useEffect(() => {
        getAdminclient();
        getcategoryplanlist();
    }, []);




    const getcategoryplanlist = async () => {
        try {
            const response = await getActivecategoryplan(token);
            if (response.status) {
                setCategory(response.data);
                if (response.data.length > 0) {
                    setSelectedCategoryId('all');
                }
            }
        } catch (error) {
            console.log("Error fetching categories");
        }
        setIsLoading(false);
    };





    const getAdminclient = async () => {
        try {
            const response = await getplanlist(token);
            if (response.status) {
                setClients(response.data);
            }
        } catch (error) {
            console.log("Failed to fetch plans", error);
        }
    };




    const Deleteplanbyadmin = async (_id) => {
        try {
            const result = await showCustomAlert("confirm", "Do you want to delete this plan? This action cannot be undone.");

            if (result.isConfirmed) {
                const response = await Deleteplan(_id, token);
                if (response.status) {
                    showCustomAlert('Success', 'The plan has been successfully deleted.');
                    getAdminclient();
                }
            } else {
                showCustomAlert('info', 'The plan deletion was cancelled.');
            }
        } catch (error) {
            showCustomAlert('error', 'There was an error deleting the plan.');
        }
    };




    const handleSwitchChange = async (event, id) => {
        const originalChecked = event.target.checked;
        const user_active_status = originalChecked ? "active" : "inactive";
        const data = { id: id, status: user_active_status };

        const result = await showCustomAlert('confirm', 'Do you want to change the package status?');
        if (result.isConfirmed) {
            try {
                const response = await changeplanstatus(data, token);
                if (response.status) {
                    showCustomAlert('Success', 'The plan status has been successfully updated.');
                }
                getcategoryplanlist();
                getAdminclient();
            } catch (error) {
                showCustomAlert('error', 'There was an error updating the plan status.');
            }
        } else {
            event.target.checked = !originalChecked;
            getcategoryplanlist();
        }
    };




    const stripHtmlTags = (input) => {
        if (!input) return '';
        return input.replace(/<\/?[^>]+(>|$)/g, '');
    };

    const loadAll = () => {
        setExpanded(true);
        setVisibleCount(category.length);
    };

    const showLess = () => {
        setExpanded(false);
        setTimeout(() => setVisibleCount(10), 300);
    };






    const freeTrialCategories = category.filter(cat => cat.freetrial_status === 1);

    const filteredClients = clients.filter(client => {
        const currentCategory = category.find(cat => cat._id === client.category);
        if (activeTab === 'free') {
            const isFreeTrialCategory = currentCategory?.freetrial_status === 1;

            const isMatchingCategory = selectedCategoryId === 'all' || client.category === selectedCategoryId;

            return isMatchingCategory && isFreeTrialCategory;
        }

        const isMatchingCategory = selectedCategoryId === 'all' || client.category === selectedCategoryId;
        return isMatchingCategory;
    });




    return (
        <Content Page_title="Package" route="/admin/addplan" button_status={true} button_title="Add Package">

            <ul className="nav nav-pills mb-3 d-flex align-items-center justify-content-center gap-2" role="tablist">
                <li className="nav-item">
                    <button style={{ width: '250px' }} className={`nav-link ${activeTab === 'all' ? 'active' : ''}`} onClick={() => setActiveTab('all')}>
                        All Plans
                    </button>
                </li>
                <li className="nav-item">
                    <button style={{ width: '250px' }} className={`nav-link ${activeTab === 'free' ? 'active' : ''}`} onClick={() => setActiveTab('free')}>
                        Free Trials Plans
                    </button>
                </li>

            </ul>
            <hr />
            <ul className="nav nav-pills mb-3 d-flex align-items-center justify-content-center gap-2" role="tablist">
                <li className=" mx-2" />


                <li className="nav-item">
                    <a
                        className={`nav-link ${selectedCategoryId === 'all' ? 'active' : ''}`}
                        onClick={() => setSelectedCategoryId('all')}
                    >
                        All Categories
                    </a>
                </li>

                {(activeTab === 'free' ? freeTrialCategories : category)
                    .slice(0, visibleCount)
                    .map((cat) => (

                        <li className="nav-item" key={cat._id}>
                            <a
                                className={`nav-link ${cat._id === selectedCategoryId ? 'active' : ''}`}
                                onClick={() => setSelectedCategoryId(cat._id)}
                            >
                                <div className="d-flex align-items-center">
                                    <div className="tab-title">{cat.title}</div>
                                </div>
                            </a>
                        </li>

                    ))}


                {activeTab === 'all' ? category.length > 10 && (
                    <li className="nav-item d-flex align-items-center gap-1">
                        {visibleCount < category.length && (
                            <button className="nav-link p-0" onClick={loadAll}>🔽</button>
                        )}
                        {visibleCount > 10 && (
                            <button className="nav-link p-0" onClick={showLess}>🔼</button>
                        )}
                    </li>
                ) :

                    freeTrialCategories.length > 10 && (
                        <li className="nav-item d-flex align-items-center gap-1">
                            {visibleCount < freeTrialCategories.length && (
                                <button className="nav-link p-0" onClick={loadAll}>🔽</button>
                            )}
                            {visibleCount > 10 && (
                                <button className="nav-link p-0" onClick={showLess}>🔼</button>
                            )}
                        </li>
                    )}
            </ul>



            {isLoading ? (
                <Loader />
            ) : filteredClients.length > 0 ? (
                <div className="tab-content">
                    <div className="tab-pane fade active show">
                        <div className="pricing-section mt-5">
                            <div className="card-container">
                                <div className="row">
                                    {filteredClients.map((client) =>
                                        category.find(cat => cat._id === client.category) ? (
                                            <div className="col-md-6 mb-3" key={client._id}>
                                                <div className="pricing-card">
                                                    <div className="row">
                                                        <div className="col-md-6 d-flex justify-content-start">
                                                            <span className="badge bg-primary">
                                                                {category.find(cat => cat._id === client.category)?.servicesDetails.map((item, index) => (
                                                                    <span key={item._id}>
                                                                        {item.title}{index < category.find(cat => cat._id === client.category)?.servicesDetails.length - 1 && ', '}
                                                                    </span>
                                                                ))}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-6 d-flex justify-content-end">
                                                            <span className="badge bg-primary">
                                                                {category.find(cat => cat._id === client.category)?.title || ''}
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row justify-content-end mb-3">
                                                        <div className="col-md-6 d-flex justify-content-start">
                                                            <div className="form-check form-switch form-check-info">
                                                                <input
                                                                    className="form-check-input toggleswitch"
                                                                    type="checkbox"
                                                                    defaultChecked={client.status === "active"}
                                                                    onChange={(event) => handleSwitchChange(event, client._id)}
                                                                />
                                                                <label className="checktoggle checkbox-bg"></label>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="row justify-content-between align-items-center">
                                                        <div className="col-md-6">
                                                            <h2>{client.planType}</h2>
                                                        </div>
                                                        <div className="price-section col-md-6">
                                                            <span className="discount">{client.discount}</span>
                                                            <h3 className="ms-4 text-yellow">INR {client.price}</h3>
                                                            {client.price === 0 && <span className="badge bg-success ms-2">Free</span>}
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <ul className='p-0 text-light'>
                                                        <li><b>Validity</b>: {client.validity}</li>
                                                        <li ><b>Description</b>: <textarea className='form-control my-2' value={stripHtmlTags(client.description || '')} readOnly /></li>
                                                        <li><b>Created At</b>: {fDateTime(client.created_at)}</li>
                                                    </ul>

                                                    <div className="button-group gap-2 d-sm-flex">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary w-100 w-sm-50"
                                                            onClick={() => setShowViewModal(client._id)}
                                                        >
                                                            View More
                                                        </button>

                                                        {showViewModal === client._id && (
                                                            <ReusableModal
                                                                show={true}
                                                                onClose={() => setShowViewModal(null)}
                                                                title={<>Plan Detail</>}
                                                                body={
                                                                    <ul>
                                                                        <li><b>Price</b>: {client.price}</li>
                                                                        <li><b>Validity</b>: {client.validity}</li>
                                                                        <li><b>Created At</b>: {fDateTime(client.created_at)}</li>
                                                                        <li><b>Updated At</b>: {fDateTime(client.updated_at)}</li>
                                                                        <li><b>Description</b>: <textarea className='form-control' value={stripHtmlTags(client.description || '')} readOnly /></li>
                                                                    </ul>
                                                                }
                                                            />
                                                        )}

                                                        <Link
                                                            to={`editplan/${client._id}`}
                                                            className="btn btn-light w-100 w-sm-50 mt-3 mt-sm-0"
                                                        >
                                                            Edit
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="text-center mt-5">
                    <img src="/assets/images/nodata.png" alt="No Records Found" className="w-25" />
                </div>
            )}
        </Content>
    );
};

export default Plan;
